import { catchError, tap } from 'rxjs/operators';
import { noop, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from '../environments/environment';
import { IWallet, IMovements } from '../models/interfaces/wallet.model';
import { IWebSetting } from '../models/interfaces/IWebSetting';

@Injectable({
  providedIn: 'root',
})
export class WebSettingService {
  apiURL = `${env.apiUrl}web-settings`;

  constructor(
    private http: HttpClient,
  ) {
  }

  editWebSetting(websetting: any): Observable<IWebSetting> {
    return this.http.patch<IWebSetting>(this.apiURL, websetting);
  }


  getWebsetting(): Observable<IWebSetting> {
    return this.http.get<IWebSetting>(
      `${this.apiURL}`
    );
  }

}
